import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api/client";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState({ user: null, tenant: null, branch: null, platform: null, ready: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ ...data, ready: true });
    } catch {
      // Not authenticated — still load public platform branding for LoginPage
      try {
        const { data: p } = await api.get("/platform/config");
        setState({ user: null, tenant: null, branch: null, platform: p, ready: true });
      } catch {
        setState({ user: null, tenant: null, branch: null, platform: null, ready: true });
      }
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("mr_token")) refresh();
    else {
      // Load public platform branding so login page can white-label
      (async () => {
        try {
          const { data: p } = await api.get("/platform/config");
          setState((s) => ({ ...s, platform: p, ready: true }));
        } catch { setState((s) => ({ ...s, ready: true })); }
      })();
    }
  }, [refresh]);

  const login = async (email, password, tenant_code) => {
    const { data } = await api.post("/auth/login", { email, password, tenant_code });
    localStorage.setItem("mr_token", data.token);
    await refresh();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_err) { /* ignore */ }
    localStorage.removeItem("mr_token");
    setState({ user: null, tenant: null, branch: null, platform: state.platform, ready: true });
  };

  return (
    <AuthCtx.Provider value={{ ...state, login, logout, refresh }}>{children}</AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
